import DataBreakdownSummary from './DataBreakdownSummary'

export default DataBreakdownSummary
